"use client";

import { c as _c } from "react/compiler-runtime";
import { useBlockExplorer } from "@opensea/app-kit";
import { graphql, useQuery } from "@opensea/graphql";
import { ModalFooterButton } from "@opensea/ui-kit";
import { Lock } from "@opensea/ui-kit/icons";
import { useState } from "react";
import { useTranslations } from "use-intl";
import { NETWORK_ONLY_OPERATION_CONTEXT } from "../../../constants";
import { useAddress } from "../../../polychain/hooks";
import { useScheduler } from "../../../polychain/hooks/useScheduler";
import { useScheduler_actionFragment } from "../../../polychain/hooks/useScheduler.fragment";
import { FlowActions } from "../../../stores/flowStore";
import { FeesContentLayout, FeesContentLayoutError, FeesContentLayoutSkeleton, WalletStatusIndicator } from "../common";
const EnforceCreatorFeesQuery = graphql(`
    query EnforceCreatorFeesQuery(
      $address: Address!
      $collectionSlug: String!
    ) {
      setTransferValidatorActions(
        address: $address
        collectionSlug: $collectionSlug
      ) {
        actions {
          ...useScheduler_action
        }
      }
    }
  `, [useScheduler_actionFragment]);
export const EnforceCreatorFeesFlow = t0 => {
  const $ = _c(74);
  const {
    collectionSlug
  } = t0;
  const t = useTranslations("wallet.EnforceCreatorFeesFlow");
  const address = useAddress();
  const [transactionIdentifier, setTransactionIdentifier] = useState();
  const {
    getTransactionUrl,
    getName
  } = useBlockExplorer(transactionIdentifier?.chain);
  const t1 = address ?? "";
  let t2;
  if ($[0] !== collectionSlug || $[1] !== t1) {
    t2 = {
      address: t1,
      collectionSlug
    };
    $[0] = collectionSlug;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = !address;
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = {
      query: EnforceCreatorFeesQuery,
      variables: t2,
      pause: t3,
      context: NETWORK_ONLY_OPERATION_CONTEXT
    };
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const [t5] = useQuery(t4);
  const {
    data,
    fetching,
    error
  } = t5;
  let t6;
  if ($[6] !== data?.setTransferValidatorActions.actions) {
    t6 = data?.setTransferValidatorActions.actions || [];
    $[6] = data?.setTransferValidatorActions.actions;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const actions = t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = async lastResponse => {
      const tx = lastResponse;
      setTransactionIdentifier(tx.transactionIdentifier);
      FlowActions.onSuccess();
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== actions) {
    t8 = {
      actions,
      onAllActionsCompleted: t7,
      autoStartEmbeddedWallet: true
    };
    $[9] = actions;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const {
    start,
    isPending,
    isLoading,
    isDone,
    error: schedulerError
  } = useScheduler(t8);
  if (fetching) {
    let t9;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <FeesContentLayoutSkeleton />;
      $[11] = t9;
    } else {
      t9 = $[11];
    }
    return t9;
  }
  if (error || !data?.setTransferValidatorActions.actions.length) {
    let t9;
    if ($[12] !== t) {
      t9 = t("close");
      $[12] = t;
      $[13] = t9;
    } else {
      t9 = $[13];
    }
    let t10;
    if ($[14] !== t9) {
      t10 = <ModalFooterButton onClick={FlowActions.endFlow} variant="secondary">{t9}</ModalFooterButton>;
      $[14] = t9;
      $[15] = t10;
    } else {
      t10 = $[15];
    }
    let t11;
    if ($[16] !== t) {
      t11 = t("title");
      $[16] = t;
      $[17] = t11;
    } else {
      t11 = $[17];
    }
    let t12;
    if ($[18] !== t10 || $[19] !== t11) {
      t12 = <FeesContentLayoutError footer={t10} icon={Lock} title={t11} />;
      $[18] = t10;
      $[19] = t11;
      $[20] = t12;
    } else {
      t12 = $[20];
    }
    return t12;
  }
  const state = isDone ? "success" : isPending || isLoading ? "pending" : "error";
  if (state === "success") {
    let t9;
    if ($[21] !== getTransactionUrl || $[22] !== transactionIdentifier) {
      t9 = transactionIdentifier ? getTransactionUrl(transactionIdentifier.hash) : "";
      $[21] = getTransactionUrl;
      $[22] = transactionIdentifier;
      $[23] = t9;
    } else {
      t9 = $[23];
    }
    const explorerUrl = t9;
    let t10;
    if ($[24] !== collectionSlug || $[25] !== t) {
      t10 = t("successDescription", {
        collectionName: collectionSlug
      });
      $[24] = collectionSlug;
      $[25] = t;
      $[26] = t10;
    } else {
      t10 = $[26];
    }
    let t11;
    if ($[27] !== explorerUrl || $[28] !== getName || $[29] !== t) {
      t11 = explorerUrl && <ModalFooterButton href={explorerUrl} target="_blank" variant="secondary">{t("viewOnEtherscan", {
          explorerName: getName()
        })}</ModalFooterButton>;
      $[27] = explorerUrl;
      $[28] = getName;
      $[29] = t;
      $[30] = t11;
    } else {
      t11 = $[30];
    }
    let t12;
    if ($[31] !== t) {
      t12 = t("close");
      $[31] = t;
      $[32] = t12;
    } else {
      t12 = $[32];
    }
    let t13;
    if ($[33] !== t12) {
      t13 = <ModalFooterButton onClick={FlowActions.endFlow}>{t12}</ModalFooterButton>;
      $[33] = t12;
      $[34] = t13;
    } else {
      t13 = $[34];
    }
    let t14;
    if ($[35] !== t11 || $[36] !== t13) {
      t14 = <>{t11}{t13}</>;
      $[35] = t11;
      $[36] = t13;
      $[37] = t14;
    } else {
      t14 = $[37];
    }
    let t15;
    if ($[38] !== t) {
      t15 = t("successTitle");
      $[38] = t;
      $[39] = t15;
    } else {
      t15 = $[39];
    }
    let t16;
    if ($[40] !== t) {
      t16 = t("updateComplete");
      $[40] = t;
      $[41] = t16;
    } else {
      t16 = $[41];
    }
    let t17;
    if ($[42] !== t16) {
      t17 = <WalletStatusIndicator state="complete">{t16}</WalletStatusIndicator>;
      $[42] = t16;
      $[43] = t17;
    } else {
      t17 = $[43];
    }
    let t18;
    if ($[44] !== t10 || $[45] !== t14 || $[46] !== t15 || $[47] !== t17) {
      t18 = <FeesContentLayout body={t10} footer={t14} icon={Lock} title={t15} walletStatus={t17} />;
      $[44] = t10;
      $[45] = t14;
      $[46] = t15;
      $[47] = t17;
      $[48] = t18;
    } else {
      t18 = $[48];
    }
    return t18;
  }
  let t9;
  if ($[49] !== t) {
    t9 = t("description");
    $[49] = t;
    $[50] = t9;
  } else {
    t9 = $[50];
  }
  let t10;
  if ($[51] !== t) {
    t10 = t("close");
    $[51] = t;
    $[52] = t10;
  } else {
    t10 = $[52];
  }
  let t11;
  if ($[53] !== t10) {
    t11 = <ModalFooterButton onClick={FlowActions.endFlow} variant="secondary">{t10}</ModalFooterButton>;
    $[53] = t10;
    $[54] = t11;
  } else {
    t11 = $[54];
  }
  let t12;
  if ($[55] !== t) {
    t12 = t("title");
    $[55] = t;
    $[56] = t12;
  } else {
    t12 = $[56];
  }
  let t13;
  if ($[57] !== isLoading || $[58] !== t) {
    t13 = isLoading && t("accepting");
    $[57] = isLoading;
    $[58] = t;
    $[59] = t13;
  } else {
    t13 = $[59];
  }
  let t14;
  if ($[60] !== isPending || $[61] !== t) {
    t14 = isPending && t("acceptInWallet");
    $[60] = isPending;
    $[61] = t;
    $[62] = t14;
  } else {
    t14 = $[62];
  }
  const t15 = schedulerError && String(schedulerError);
  let t16;
  if ($[63] !== start || $[64] !== state || $[65] !== t13 || $[66] !== t14 || $[67] !== t15) {
    t16 = <WalletStatusIndicator onClick={start} state={state}>{t13}{t14}{t15}</WalletStatusIndicator>;
    $[63] = start;
    $[64] = state;
    $[65] = t13;
    $[66] = t14;
    $[67] = t15;
    $[68] = t16;
  } else {
    t16 = $[68];
  }
  let t17;
  if ($[69] !== t11 || $[70] !== t12 || $[71] !== t16 || $[72] !== t9) {
    t17 = <FeesContentLayout body={t9} footer={t11} icon={Lock} title={t12} walletStatus={t16} />;
    $[69] = t11;
    $[70] = t12;
    $[71] = t16;
    $[72] = t9;
    $[73] = t17;
  } else {
    t17 = $[73];
  }
  return t17;
};